@if (filterList.length > 0) {
  <div class="mt-10 currency-filter-wrapper">
    @for (filter of filterList; track filter) {
      <a
        class="filter-button btn btn-primary button-currency-filter"
        (click)="onFilterClick(filter)"
        [ngClass]="{ active: currentFilter?.value === filter?.value }"
        (keydown.enter)="onFilterClick(filter)"
        [tabIndex]="0">
        {{ filter.name | translate }}
      </a>
    }
  </div>
}
